<template>
  <vg-card>
    <vg-form>
      <vg-field
          v-for="item in projectList"
          :key="item.projectId"
          :label="item.projectName"
          is-link
          @click="choiceProject(item)"
      />
    </vg-form>
  </vg-card>
</template>
<script>

import {mapState} from "pinia";
// import useformStore from "@/store/form";
//import eventBus from '@/router/eventBus';
import useformStore from "@/store/sporadicChargeform";
import useProjectStore from "@/store/project";
import VgCard from "@/components/Commons/VgCard.vue";
import VgForm from "@/components/Commons/VgForm.vue";
import VgField from "@/components/Commons/VgField.vue";
import chargeProjectStore from "@/store/chargeProject";

export default {
  name: "choiceProject",
  components: {
    VgField,
    VgForm,
    VgCard
  },
  props: {},
  data() {
    return {
      projectList: [],
      isChangePro: false
    };
  },
  created() {
    this.getProjectList();
  },
  computed: {
    ...mapState(useformStore, ['form']),
    ...mapState(chargeProjectStore, ['chargeProject']),
  },
  methods: {
    getProjectList() {
      const chargeProjectList = chargeProjectStore();
      console.log("ssssss");
      console.log(chargeProjectList.getChangePro)
      this.projectList = chargeProjectList.getProjectList;
      this.isChangePro = chargeProjectList.getChangePro;
    },
    choiceProject(item) {
      console.log("测试状态");
      console.log(this.isChangePro);
      if (this.isChangePro) {
        const projectStore = useProjectStore();
        projectStore.project(item, false);
      } else {
        const formStore = useformStore();
        formStore.setForm(
            {
              strProject: item,
              strSubject: this.formStore?.strSubject,
              strSubSubject: this.formStore?.strSubSubject,
              strPrice: this.formStore?.strPrice,
              strRemarks: this.formStore?.strRemarks,
              paymentUpperLimit: this.formStore?.paymentUpperLimit,
            }
        )
      }
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.choice-list {
  width: 353px;
  border: 1px solid #E7E5E7;
  border-radius: 10px;
  margin: 10px;
}

.title {
  padding: 10px;
}

.choice-project-button {
  width: 70px;
  height: 36px;
  float: right;
  margin-top: -40px;
  margin-right: 40px;
}

.choice-project-search >>> .van-icon-search:before {
  content: '';
}

.choice-project-search {
  width: 275px;
  height: 44px;
  /* float: left; */
}

.choice-project-search >>> .van-search__content {
  border: 1px solid #E7E5E7;
  background-color: white;
}
</style>
